// extracted by mini-css-extract-plugin
var _1 = "SubMenu-moduleemail__Tq4c5";
var _2 = "SubMenu-moduleinput__QWX6n";
var _3 = "SubMenu-modulewrapper__sD_0h";
var _4 = "SubMenu-modulewrapperBtn__F4Uo2";
export { _1 as "email", _2 as "input", _3 as "wrapper", _4 as "wrapperBtn" }
